import { render, staticRenderFns } from "./edit-box.vue?vue&type=template&id=3fbe7872&scoped=true&"
import script from "./edit-box.vue?vue&type=script&lang=js&"
export * from "./edit-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbe7872",
  null
  
)

export default component.exports